<script lang="ts">
	import ActivityLog from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/CommonDeviceTabs/ActivityLog.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
	export let openedEventTimestamp: number | null = null;
</script>

<ActivityLog {device} {openedEventTimestamp} />
